import { GetConsentStatusResponseBodySubscriptionsItemDTO } from '@ketch-com/figurehead'
import { SubscriptionSource } from '@ketch-sdk/ketch-types'
import { Box, styled } from '@mui/material'
import { SourceLabels } from 'pages/insights/auditLog/constants'
import { SummaryCard, SummaryCardProps } from 'pages/insights/auditLog/components/SummaryCard'
import React, { useMemo } from 'react'
import { formatDateTimeFromUnix } from 'utils/helpers/dateTime'

type ChannelCardsProps = {
  channel: GetConsentStatusResponseBodySubscriptionsItemDTO
}

const CardsBox = styled(Box)({
  display: 'flex',
  gap: 16,
  marginBottom: 24,
  marginLeft: 16,
})

export const ChannelCards: React.FC<ChannelCardsProps> = ({ channel }) => {
  const cardData: SummaryCardProps[] = useMemo<SummaryCardProps[]>(
    () => [
      {
        fieldName: 'Last Updated',
        fieldValue: formatDateTimeFromUnix(channel.collectedAt),
        icon: 'OCalendar',
      },
      {
        fieldName: 'Property',
        fieldValue: channel.propertyName,
        icon: 'FGlobe',
      },
      {
        fieldName: 'Interaction Method',
        fieldValue: SourceLabels[channel.context?.source as SubscriptionSource] || channel.context?.source || 'Unknown',
        icon: 'OPointer',
      },
    ],
    [channel],
  )

  return (
    <CardsBox>
      {cardData.map(card => (
        <SummaryCard key={card.fieldName} {...card} />
      ))}
    </CardsBox>
  )
}
